import { Alert, Button, Checkbox, Group, Paper, ScrollArea, Stack, Text, Title } from '@mantine/core';
import { useState } from 'react';
import { api, izvedi } from '../api/odjemalec';
import { sporocilo } from '../api/napaka';
import { IME_APLIKACIJE } from '../ime';
import { BesediloPogojev } from '../pogoji/BesediloPogojev';
import { seja } from '../seja/seja';
import { TemnoOzadje } from '../postavitev/TemnoOzadje';
import { barve } from '../tema';

/**
 * Splošni pogoji ob prvi prijavi – kot PrivacyPolicyDialog v Swingu: besedilo je v oknu ({@link BesediloPogojev}, tudi
 * na {@code /splosni-pogoji}); brez sprejema aplikacije ni mogoče uporabljati (»Ne sprejmem« odjavi). Sprejem se
 * zapiše pri uporabniku na strežniku.
 */
export function SplosniPogoji() {
  const [sprejmem, setSprejmem] = useState(false);
  const [napaka, setNapaka] = useState<string | null>(null);
  const [zavrnitev, setZavrnitev] = useState(false);
  const [dela, setDela] = useState(false);

  const potrdi = async () => {
    if (!sprejmem) {
      setNapaka(`Za uporabo aplikacije ${IME_APLIKACIJE} se morate strinjati s splošnimi pogoji.`);
      return;
    }
    setDela(true);
    setNapaka(null);
    try {
      await izvedi(api.POST('/api/seja/splosni-pogoji'));
      seja.pogojiSprejeti();
    } catch (e) {
      setNapaka(sporocilo(e));
    } finally {
      setDela(false);
    }
  };

  return (
    <TemnoOzadje sirina={720}>
      <Paper radius="lg" p={{ base: 20, sm: 36 }} shadow="xl">
        <Title order={2} size="h3" mb="xs">
          Splošni pogoji
        </Title>
        <Stack gap="sm">
          <Text size="sm">
            Pozdravljeni, zahvaljujemo se vam za uporabo aplikacije {IME_APLIKACIJE}. Preden nadaljujete, preberite in
            sprejmite splošne pogoje. Vedno so vam na voljo v aplikaciji (Informacije → Splošni pogoji).
          </Text>
          <ScrollArea.Autosize
            mah="50vh"
            type="auto"
            offsetScrollbars
            style={{ border: `1px solid ${barve.obroba}`, borderRadius: 8 }}
            p="sm"
          >
            <BesediloPogojev />
          </ScrollArea.Autosize>
          <Checkbox
            label="Sprejemam splošne pogoje."
            checked={sprejmem}
            onChange={(e) => {
              setSprejmem(e.currentTarget.checked);
              setNapaka(null);
            }}
            error={napaka ?? undefined}
          />
          {zavrnitev && (
            <Alert color="yellow" variant="light">
              <Text size="sm" mb="xs">
                Brez sprejema splošnih pogojev aplikacije {IME_APLIKACIJE} ne morete uporabljati. Se želite odjaviti?
              </Text>
              <Group gap="xs">
                <Button size="xs" color="red" onClick={() => void seja.odjava()}>
                  Odjava
                </Button>
                <Button size="xs" variant="subtle" onClick={() => setZavrnitev(false)}>
                  Nazaj
                </Button>
              </Group>
            </Alert>
          )}
          <Group justify="flex-end" gap="xs">
            <Button variant="subtle" onClick={() => setZavrnitev(true)} disabled={dela}>
              Ne sprejmem
            </Button>
            <Button onClick={() => void potrdi()} loading={dela}>
              Potrdi
            </Button>
          </Group>
        </Stack>
      </Paper>
    </TemnoOzadje>
  );
}
